import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { Grid } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import dayjs from 'dayjs'
import { toast } from 'react-toastify'

import TopSection from '../../LT/TopSection'
import { MultiDropdown } from '../../../components/common/MultiDropdown'
import ButtonComponent from '../../../components/common/button/Button'
import { fetchContractMaintenanceData } from '../../../redux/actions/ContractMaintenance'
import { Loader } from '../../../components/common/Loader'
import DatePicker from '../../../components/common/DatePicker'
import { postNewContractData } from '../../../redux/actions/ContractMaintenance/NewContract'
import { getCMUploadedViewEndpoint, postNewContractDataEndpoint, postSubmitUploadEndpoint, postUpdateContractDataEndpoint, postUpdateTargetValueEndpoint } from '../../../common/endpoints'
import { postUpdateContractData } from '../../../redux/actions/ContractMaintenance/UpdateContract'
import { postUpdateTargetValue } from '../../../redux/actions/ContractMaintenance/UpdateTargetValue'
import DownloadUpload from './DownloadUpload'
import DataDetails from './DownloadUpload/DataDetails'
import { fetchCMUploadedViewData } from '../../../redux/actions/ContractMaintenance/CMUploadedView'
import { setSelectedItem } from '../../../redux/actions/SupportTicket/selectionSlice'
import { postSubmitUpload } from '../../../redux/actions/ContractMaintenance/SubmitUpload'

const ContractMaintenance = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
      vendorNumber: [],
      plantNumber: [],
      materialNumber: [],
      agreementNumber: [],
      currency: [],
      companyCode: [],
      purchaseGroup: [],
      purchaseOrg: [],
      validityStartDate: null,
      validityEndDate: null,
    });
  const [vendorNumberData, setVendorNumberData] = useState([]);
  const [plantNumberData, setPlantNumberData] = useState([]);
  const [materialNumberData, setMaterialNumberData] = useState([]);
  const [agreementNumberData, setAgreementNumberData] = useState([]);
  const [currencyData, setCurrencyData] = useState([]);
  const [companyCodeData, setCompanyCodeData] = useState([]);
  const [purchasingGroupData, setPurchasingGroupData] = useState([]);
  const [purchasingOrganisationData, setPurchasingOrganisationData] = useState([]);
  const [showViewModal, setShowViewModal] = useState(false);
  const [viewUploadedData, setViewUploadedData] = useState([]);
  const [rowsData, setRowsData] = useState([]);
  const [disableSubmitBtn, setDisableSubmitBtn] = useState(true);
  const [contractType, setContractType] = useState('NEW');
  const userRole = localStorage.getItem("CDRole");

  const userEmail = localStorage.getItem("data");
  const userName = localStorage.getItem("userName");

  const cleanUsername = (name) => {
    return name.replace(/\s*\[C\]/, ""); // Removes "[C]" with optional leading space
  };

  const getUniqueValues = (data = [], key) => {
    if (data?.length > 0) {
      // const uniqueValues = [...new Set(data?.map(item => item[key]))];
      const uniqueValues = [...new Set(data?.map(item => item[key]).filter(Boolean))];
      return uniqueValues?.map(value => ({ label: value, value: value, title: value }));
    }
    else {
      return []
    }
  };

  const rowSelection = useMemo(() => {
    return {
      mode: "multiRow",
      isRowSelectable: (rowNode) =>
        rowNode.data
          ? true
          : false,
    };
  }, []);

  const onSelectionChanged = (params) => {
    const selectedRowsOnCurrentPage = [];
    // const currentPage = params.api.paginationGetCurrentPage();
    // const pageSize = params.api.paginationGetPageSize();
    // let index = 0;

    // params.api.forEachNodeAfterFilterAndSort((node) => {
    //   const nodePage = Math.floor(index / pageSize);
    //   if (nodePage === currentPage && node.isSelected()) {
    //     selectedRowsOnCurrentPage.push(node.data);
    //   }
    //   index++;
    // });

    params.api.forEachNodeAfterFilterAndSort((node) => {
      if (node.isSelected()) {
        selectedRowsOnCurrentPage.push(node.data);
      }
    });

    setRowsData(selectedRowsOnCurrentPage);
    dispatch(setSelectedItem(selectedRowsOnCurrentPage));
    setDisableSubmitBtn(selectedRowsOnCurrentPage.length === 0);
  };
  
  const handleViewUpload = (event) => {
    event.preventDefault();
    setShowViewModal(true);
    getAllUploadedData();
  }

  const handleContractChange = (event) => {
      setContractType(event.target.value);
  }

  const getAllUploadedData = useCallback(async () => {
      setIsLoading(true);
      try {
      const response = await dispatch(
          fetchCMUploadedViewData({
          dynamicEndpoint: `${getCMUploadedViewEndpoint}?userId=${userEmail}`,
          })
      );
      if (response.meta.requestStatus === "fulfilled") {
          setIsLoading(false);
          setViewUploadedData(response.payload.cdExcelContractList || []);
          console.log("Fetched data:", response.payload);
      } else {
          setIsLoading(false);
          console.log(
          "Failed to fetch data:",
          response.payload.responseMessage
          );
      }
      } catch (error) {
      console.log("API error:", error);
      }
  }, [dispatch, setIsLoading, userEmail]);


  const uploadSubmitHandler = async () => {
    setIsLoading(true);
      try {
      const response = await dispatch(
          postSubmitUpload({
          dynamicEndpoint: `${postSubmitUploadEndpoint}?userName=${cleanUsername(userName)}&cmType=${contractType}&userEmailList=${userEmail}`,
          data: rowsData,
          })
      );
      if (response.meta.requestStatus === "fulfilled") {
          setIsLoading(false);
          setShowViewModal(false);
          toast.success( `${response.payload}`, {
            position: "top-right",
            autoClose: 3000,
          })
      } else {
          setIsLoading(false);
          toast.error( `something went wrong, please try again`, {
            position: "top-right",
            autoClose: 3000,
          })
      }
      } catch (error) {
      console.log("API error:", error);
      }
  }
  
  const NewContractHandler = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    try {
      const postcontractFilterData = await dispatch(
        postNewContractData({
          dynamicEndpoint: `${postNewContractDataEndpoint}?userId=${userEmail}&userName=${cleanUsername(userName)}`,
          data: {
            vendorNumbers : formData?.vendorNumber?.map(item => item?.value),
            plantNumbers : formData?.plantNumber?.map(item => item?.value),
            materialNumbers : formData?.materialNumber?.map(item => item?.value),
            agreementNumbers : formData?.agreementNumber?.map(item => item?.value),
            validityStartDate : formData.validityStartDate ? dayjs(formData.validityStartDate).format("DD-MM-YYYY") : null,
            validityEndDate : formData.validityEndDate ? dayjs(formData.validityEndDate).format("DD-MM-YYYY") : null,
            currencies : formData?.currency?.map(item => item?.value),
            companyCodes : formData?.companyCode?.map(item => item?.value),
            purchaseGroups : formData?.purchaseGroup?.map(item => item?.value),
            purchaseOrgs : formData?.purchaseOrg?.map(item => item?.value),
          }
        })
      );
      if (postcontractFilterData.meta.requestStatus === "fulfilled") {
        localStorage.setItem(
            "contractMaintenancePostFilterData",
            JSON.stringify({
              vendorNumbers : formData?.vendorNumber?.map(item => item?.value),
              plantNumbers : formData?.plantNumber?.map(item => item?.value),
              materialNumbers : formData?.materialNumber?.map(item => item?.value),
              agreementNumbers : formData?.agreementNumber?.map(item => item?.value),
              validityStartDate : formData.validityStartDate ? dayjs(formData.validityStartDate).format("DD-MM-YYYY") : null,
              validityEndDate : formData.validityEndDate ? dayjs(formData.validityEndDate).format("DD-MM-YYYY") : null,
              currencies : formData?.currency?.map(item => item?.value),
              companyCodes : formData?.companyCode?.map(item => item?.value),
              purchaseGroups : formData?.purchaseGroup?.map(item => item?.value),
              purchaseOrgs : formData?.purchaseOrg?.map(item => item?.value),
            })
          );
        setIsLoading(false);
        navigate('/contract-maintenance/new-contract');
      } else {
        console.error(
          "contractMaintenanceFilter:",
          postcontractFilterData.error
        );
        toast.error(`Something went wrong, Please try again`, {
          autoClose: 2000,
        });
        setIsLoading(false);
      }
    } catch (error) {
      console.log('API error:', error);
      setIsLoading(false);
    }
  }

  const updateContractHandler = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    try {
      const postUpdateContractFilterData = await dispatch(
        postUpdateContractData({
          dynamicEndpoint: `${postUpdateContractDataEndpoint}?userId=${userEmail}&userName=${cleanUsername(userName)}`,
          data: {
            vendorNumbers : formData?.vendorNumber?.map(item => item?.value),
            plantNumbers : formData?.plantNumber?.map(item => item?.value),
            materialNumbers : formData?.materialNumber?.map(item => item?.value),
            agreementNumbers : formData?.agreementNumber?.map(item => item?.value),
            validityStartDate : formData.validityStartDate ? dayjs(formData.validityStartDate).format("DD-MM-YYYY") : null,
            validityEndDate : formData.validityEndDate ? dayjs(formData.validityEndDate).format("DD-MM-YYYY") : null,
            currencies : formData?.currency?.map(item => item?.value),
            companyCodes : formData?.companyCode?.map(item => item?.value),
            purchaseGroups : formData?.purchaseGroup?.map(item => item?.value),
            purchaseOrgs : formData?.purchaseOrg?.map(item => item?.value),
          }
        })
      );
      if (postUpdateContractFilterData.meta.requestStatus === "fulfilled") {
        localStorage.setItem(
            "contractMaintenancePostUpdateFilterData",
            JSON.stringify({
              vendorNumbers : formData?.vendorNumber?.map(item => item?.value),
              plantNumbers : formData?.plantNumber?.map(item => item?.value),
              materialNumbers : formData?.materialNumber?.map(item => item?.value),
              agreementNumbers : formData?.agreementNumber?.map(item => item?.value),
              validityStartDate : formData.validityStartDate ? dayjs(formData.validityStartDate).format("DD-MM-YYYY") : null,
              validityEndDate : formData.validityEndDate ? dayjs(formData.validityEndDate).format("DD-MM-YYYY") : null,
              currencies : formData?.currency?.map(item => item?.value),
              companyCodes : formData?.companyCode?.map(item => item?.value),
              purchaseGroups : formData?.purchaseGroup?.map(item => item?.value),
              purchaseOrgs : formData?.purchaseOrg?.map(item => item?.value),
            })
          );
        setIsLoading(false);
        navigate('/contract-maintenance/update-contract');
      } else {
        console.error(
          "contractMaintenanceFilter:",
          postUpdateContractFilterData.error
        );
        toast.error(`Something went wrong, Please try again`, {
          autoClose: 2000,
        });
        setIsLoading(false);
      }
    } catch (error) {
      console.log('API error:', error);
      setIsLoading(false);
    }
  }

  const updateTargetValueHandler = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    try {
      const postUpdateTargetValueData = await dispatch(
        postUpdateTargetValue({
          dynamicEndpoint: `${postUpdateTargetValueEndpoint}?userId=${userEmail}&userName=${cleanUsername(userName)}`,
          data: {
            vendorNumbers : formData?.vendorNumber?.map(item => item?.value),
            plantNumbers : formData?.plantNumber?.map(item => item?.value),
            materialNumbers : formData?.materialNumber?.map(item => item?.value),
            agreementNumbers : formData?.agreementNumber?.map(item => item?.value),
            validityStartDate : formData.validityStartDate ? dayjs(formData.validityStartDate).format("DD-MM-YYYY") : null,
            validityEndDate : formData.validityEndDate ? dayjs(formData.validityEndDate).format("DD-MM-YYYY") : null,
            currencies : formData?.currency?.map(item => item?.value),
            companyCodes : formData?.companyCode?.map(item => item?.value),
            purchaseGroups : formData?.purchaseGroup?.map(item => item?.value),
            purchaseOrgs : formData?.purchaseOrg?.map(item => item?.value),
          }
        })
      );
      if (postUpdateTargetValueData.meta.requestStatus === "fulfilled" && postUpdateTargetValueData.payload?.cmBachJobResponseDTO?.status === "Successful") {
        toast.success(`${postUpdateTargetValueData.payload?.cmBachJobResponseDTO?.message}`, {
          autoClose: 2000,
        })
        setIsLoading(false);
      } else if (postUpdateTargetValueData.meta.requestStatus === "fulfilled" && postUpdateTargetValueData.payload?.cmBachJobResponseDTO?.status === "Failed") {
        toast.warn(`${postUpdateTargetValueData.payload?.cmBachJobResponseDTO?.message}`, {
          autoClose: 2000,
          position: "bottom-center"
        });
        setIsLoading(false);
      } else {
        toast.error(`Something went wrong, Please try again`, {
          autoClose: 2000,
        });
        setIsLoading(false);
      }
    } catch (error) {
      console.log('API error:', error);
      setIsLoading(false);
    }
  }

  const handleSelectedItemsChange = (name, newSelectedItems) => {
    setFormData((prevData) => ({
      ...prevData,
      [name]: newSelectedItems,
    }));
  }

  const handleDateChange = (date, name) => {
    setFormData({
      ...formData,
      [name]: date,
    });
  };

  const fetchDataFromApi = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await dispatch(
        fetchContractMaintenanceData()
      );
      if (response.meta.requestStatus === "fulfilled") {
        setIsLoading(false);
        // setDropdownData(response.payload.filterDTOList);
        setVendorNumberData(getUniqueValues(response?.payload?.filterDTOList, 'vendorNumber'));
        setPlantNumberData(getUniqueValues(response?.payload?.filterDTOList, 'plantNumber'));
        setMaterialNumberData(getUniqueValues(response?.payload?.filterDTOList, 'materialNumber'));
        setAgreementNumberData(getUniqueValues(response?.payload?.filterDTOList, 'agreementNumber'));
        setCurrencyData(getUniqueValues(response?.payload?.filterDTOList, 'currency'));
        setCompanyCodeData(getUniqueValues(response?.payload?.filterDTOList, 'companyCode'));
        setPurchasingGroupData(getUniqueValues(response?.payload?.filterDTOList, 'purchaseGroup'))
        setPurchasingOrganisationData(getUniqueValues(response?.payload?.filterDTOList, 'purchaseOrg'));
      } else {
        setIsLoading(false);
        console.log(
          "Failed to fetch data:",
          response.payload.responseMessage
        );
      }
    } catch (error) {
      console.log("API error:", error);
    }
  }, [dispatch]);

  useEffect(() => {
    fetchDataFromApi();
  }, [fetchDataFromApi])

  const isFormEmpty = Object.values(formData).every(
    val => Array.isArray(val) ? val.length === 0 : val === null
  );

  return (
    <>
      <TopSection
        labelList={[
          { title: "Home", path: "/landing-page" },
          { title: "Contract Maintenance" },
        ]}
        hideHeader={true}
        headerName={"Contract Maintenance"}
      />
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <div
            style={{
              border: "1px solid #ddd",
              borderRadius: "8px",
              padding: "20px",
            }}
          >
            <Grid container spacing={2}>
              <Grid
                item
                xs={12}
                md={4}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <label className="label-position" htmlFor="hierarchy">
                  Vendor Number
                </label>
                <MultiDropdown
                  id="vendorNumber"
                  name="vendorNumber"
                  options={vendorNumberData}
                  enableMultiValueSearch
                  selectedItemsData={formData?.vendorNumber}
                  onChangeItems={handleSelectedItemsChange}
                />
              </Grid>
              <Grid
                item
                xs={12}
                md={4}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <label className="label-position" htmlFor="hierarchy">
                  Plant Number
                </label>
                <MultiDropdown
                  id="plantNumber"
                  name="plantNumber"
                  options={plantNumberData}
                  enableMultiValueSearch
                  selectedItemsData={formData?.plantNumber}
                  onChangeItems={handleSelectedItemsChange}
                />
              </Grid>
              <Grid
                item
                xs={12}
                md={4}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <label className="label-position" htmlFor="hierarchy">
                  Material Number
                </label>
                <MultiDropdown
                  id="materialNumber"
                  name="materialNumber"
                  options={materialNumberData}
                  enableMultiValueSearch
                  selectedItemsData={formData?.materialNumber}
                  onChangeItems={handleSelectedItemsChange}
                />
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid
                item
                xs={12}
                md={4}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <label className="label-position" htmlFor="hierarchy">
                  Agreement Number
                </label>
                <MultiDropdown
                  id="agreementNumber"
                  name="agreementNumber"
                  options={agreementNumberData}
                  enableMultiValueSearch
                  selectedItemsData={formData?.agreementNumber}
                  onChangeItems={handleSelectedItemsChange}
                />
              </Grid>
              <Grid
                item
                xs={12}
                md={4}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <label className="label-position" htmlFor="hierarchy">
                  Currency
                </label>
                <MultiDropdown
                  id="currency"
                  name="currency"
                  options={currencyData}
                  enableMultiValueSearch
                  selectedItemsData={formData?.currency}
                  onChangeItems={handleSelectedItemsChange}
                />
              </Grid>
              <Grid
                item
                xs={12}
                md={4}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <label className="label-position" htmlFor="hierarchy">
                  Company Code
                </label>
                <MultiDropdown
                  id="companyCode"
                  name="companyCode"
                  options={companyCodeData}
                  enableMultiValueSearch
                  selectedItemsData={formData?.companyCode}
                  onChangeItems={handleSelectedItemsChange}
                />
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid
                item
                xs={12}
                md={4}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <label className="label-position" htmlFor="hierarchy">
                  Purchasing Group
                </label>
                <MultiDropdown
                  id="purchaseGroup"
                  name="purchaseGroup"
                  options={purchasingGroupData}
                  enableMultiValueSearch
                  selectedItemsData={formData?.purchaseGroup}
                  onChangeItems={handleSelectedItemsChange}
                />
              </Grid>
              <Grid
                item
                xs={12}
                md={4}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <label className="label-position" htmlFor="hierarchy">
                  Purchasing Organisation
                </label>
                <MultiDropdown
                  id="purchaseOrg"
                  name="purchaseOrg"
                  options={purchasingOrganisationData}
                  enableMultiValueSearch
                  selectedItemsData={formData?.purchaseOrg}
                  onChangeItems={handleSelectedItemsChange}
                />
              </Grid>
              <Grid
                item
                xs={12}
                md={4}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <label className="label-position" htmlFor="hierarchy">
                  Validity Start Date
                </label>
                <DatePicker
                  name="validityStartDate"
                  // label="Validity Start Date"
                  value={formData?.validityStartDate}
                  onChange={(e) => handleDateChange(e, "validityStartDate")}
                  // maxDate={props.singleDropdownData?.toDate}
                />
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid
                item
                xs={12}
                md={4}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <label className="label-position" htmlFor="hierarchy">
                  Validity End Date
                </label>
                <DatePicker
                  name="validityEndDate"
                  // label="Validity End Date"
                  value={formData?.validityEndDate}
                  onChange={(e) => handleDateChange(e, "validityEndDate")}
                  // maxDate={props.singleDropdownData?.toDate}
                />
              </Grid>
            </Grid>
            <div
              style={{
                marginTop: "30px",
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "30px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "700px",
                }}
              >
                <ButtonComponent
                  label="New Year Contract"
                  bgColor="#000"
                  color="#fff"
                  disabled={isFormEmpty}
                  onClick={NewContractHandler}
                />
                <ButtonComponent
                  label="Update Contract"
                  bgColor="#000"
                  color="#fff"
                  disabled={isFormEmpty}
                  onClick={updateContractHandler}
                />
                <ButtonComponent
                  label="Target Value - Manual"
                  bgColor="#000"
                  color="#fff"
                  disabled={isFormEmpty || userRole === "Viewer"}
                  onClick={updateTargetValueHandler}
                />
                <ButtonComponent
                  label="Review Target Update"
                  bgColor="#000"
                  color="#fff"
                  onClick={() => navigate('/contract-maintenance/review-auto-target-value')}
                />
              </div>
            </div>
          </div>
          {userRole !== "Viewer" && (
            <DownloadUpload
              isFormEmpty={isFormEmpty}
              formData={formData}
              setIsLoading={setIsLoading}
              userName={cleanUsername(userName)}
              userEmail={userEmail}
              isLoading={isLoading}
              handleViewUpload={handleViewUpload}
              setFormData={setFormData}
              handleContractChange={handleContractChange}
              contractType={contractType}
            />
          )}
          
        </>
      )}
      <DataDetails
        open={showViewModal}
        handleClose={() => setShowViewModal(false)}
        title="Uploaded Data"
        isLoading={isLoading}
        setIsLoading={setIsLoading}
        userEmail={userEmail}
        viewUploadedData={viewUploadedData}
        rowSelection={rowSelection}
        onSelectionChanged={onSelectionChanged}
        disableSubmitBtn={disableSubmitBtn}
        uploadSubmitHandler={uploadSubmitHandler}
      />
    </>
  );
}

export default ContractMaintenance